module.exports = __webpack_public_path__ + "img/4_3.430b3720.jpg";